import React from 'react';
import { getDescText, getPublishDate, getEventDate, cacheFunc } from '../../common/services/builders';
import { PropTypes } from 'prop-types';


function ListingCard({ entry, settings }) {
    return (
    <div className="column large-3">
        <article className="ui-card" style={{minHeight: 460 + 'px'}}>
            <div className="ui-card__image">
                <div className="ui-card__image-container" style={renderImage(settings, entry)}></div>
            </div>
                {renderTag(settings, entry)}
                {renderCardContent(entry)}
        </article> 
    </div>   
    );
    
}

function renderImage(settings, entry){
    let styles = {};

    var twiglobal = RegExp("twi-global.com");
    var preview = RegExp("preview-twi(.*).cloud.contensis.com");

    var currentUrl = window.location.href;

    var defaultImage =  "/site-elements/images/hero/hero-slider-1.jpg";

    // if (settings.appId !== 'OurPeopleAppId' )
    // {

    if (entry.thumbnailImage != undefined)
    {
        var thmUrlAsset = entry.thumbnailImage.asset;
        var thmUrl = thmUrlAsset != null ? thmUrlAsset.sys.uri : defaultImage; 

        // thmUrl = thmUrl.split("?")[0];

        var isAbsoluteUrlRequired = !twiglobal.test(currentUrl) && !preview.test(currentUrl) && !thmUrl.includes("microsites");
        thmUrl = isAbsoluteUrlRequired ? thmUrl = "https://live-twi.cloud.contensis.com" + thmUrl : thmUrl;

        styles = {backgroundImage: `url(${thmUrl})`};

    }
        else if( entry.heroImage != undefined ){
        styles = {backgroundImage: `url(/CachedImage.axd?ImageName=${entry.heroImage.asset.sys.uri}&Imagewidth=266&Imageheight=240)`};
    }
        else {
        styles = {backgroundImage: `url(/CachedImage.axd?ImageName=${defaultImage}&Imagewidth=266&Imageheight=240)`};
    }


    // }

    // if(entry.thumbnailImage != null && entry.thumbnailImage != ''){
    //     styles = {backgroundImage: `url(${thmUrl})`};
    // }
    // // else if(entry.heroImage != null && entry.heroImage != ''){
    // //     styles = {backgroundImage: `url(/CachedImage.axd?ImageName=${entry.heroImage.asset.sys.uri}&ImageHeight=300&ImageWidth=500)`};
    // // }
    // else {
    //     styles = {backgroundImage: `url(/CachedImage.axd?ImageName=/site-elements/images/hero/hero-slider-1.jpg&ImageHeight=300&ImageWidth=500)`};
    // }



    if (settings.appId == "OurPeopleAppId" && entry.mainImage != undefined) 
    {
        var mainImageAsset = entry.mainImage;
        var mainImageUrl = mainImageAsset != null ? entry.mainImage.asset.sys.uri : "";
        isAbsoluteUrlRequired = !twiglobal.test(currentUrl) && !preview.test(currentUrl) && !mainImageUrl.includes("microsites");
        var mainImage = mainImageUrl != null && isAbsoluteUrlRequired ? mainImage = "https://live-twi.cloud.contensis.com" + mainImageUrl : mainImageUrl;
        styles = {backgroundImage: `url(${mainImage}?w=500)`};
    }

    // if (settings.appId == "GenericShowcaseAppId" && entry.heroImage != undefined) 
    // {

    //     var imageAsset = entry.heroImage.asset;
    //     var imageUrl = imageAsset != null ? imageAsset.sys.uri : "";
    //     isAbsoluteUrlRequired = !twiglobal.test(currentUrl) && !preview.test(currentUrl) && !imageUrl.includes("microsites");
    //     var image = imageUrl != null && isAbsoluteUrlRequired ? image = "https://live-twi.cloud.contensis.com" + imageUrl : imageUrl;
    //     styles = {backgroundImage: `url(/CachedImage.axd?ImageName=${image}&Imagewidth=266&Imageheight=240)`};

    // }


    return styles;
}
function renderTag(settings, entry) {
    switch (settings.appId) {
        case 'GenericPressReleasesAppId':
        case 'news':
            return <div className="ui-card__type">Press Release</div>;
        case 'events':
            if (entry.privateEvent != null && entry.privateEvent.length > 0)
            {
            return <div className="ui-card__type private-event">{entry.eventTag}</div>;

            }else
            {
                return <div className="ui-card__type">Event</div>;

            }
            
        case 'blogs':
            return <div className="ui-card__type">Blogs</div>;
        case 'NSIRCStudentProfilesAppId' :
            return <div className="ui-card__type">PhD Student Profile</div>;
        case 'NSIRCNewsAppId' :
            return <div className="ui-card__type">Press Release</div>;
        case 'NSIRCPublicationsAppId' :
            return <div className="ui-card__type">PhD Publication</div>;
        case 'NSIRCThesesAppId' :
            return <div className="ui-card__type">PhD Theses</div>;
        case 'NSIRCDissertationsAppId' :
            return <div className="ui-card__type">MSc Dissertations</div>;
        case 'NSIRCInsightsAppId' :
            return <div className="ui-card__type">Insight</div>;
        case 'OurPeopleAppId' :
            return <div className="ui-card__type">{entry.title}</div>;
        case 'GenericShowcaseAppId' :
            if (entry.collection != null && entry.collection.length > 0)
            {
                return <div className="ui-card__type showcase-label">{entry.collection}</div>;

            }else
            {
                return;

            }

        }
}

//{entry.noindexNofollow && entry.noindexNofollow == true ? "nofollow" : ""}

function pressReleaseLink (entry) {

    var link = cacheFunc.getCachedUrl(entry);
    var rel= entry.noindexNofollow;
    var linkText = entry.title && entry.title.length < 90 ? entry.title : entry.title.substr(0, 90).trim() + '...';
    var headerLink="";

    if (rel)
    {
        headerLink = <a href={link} rel="nofollow">{linkText}</a>;
    }
     else
     {
        headerLink = <a href={link}>{linkText}</a>;
     }

    return headerLink;
    
}

function renderCardContent(entry){
    //if(entry.sys.dataFormat === 'entry'){
        switch (entry.sys.contentTypeId){
            case 'pressReleases':
            case 'genericContentWebpage':
                return <div className="ui-card__content">
                    <h3 className="ui-card__heading">                     
                        {pressReleaseLink(entry)}
                    </h3>
                    <p className="ui-card__text">{getDescText(entry)}</p>
                    <span className="ui-card__date">{getPublishDate(entry)}</span>
                </div>;
            case 'events':
                return <div className="ui-card__content">
                    {entry.eventType.length > 0 && <span className="ui-card__category">{entry.eventType[0].name}</span>}
                    <span className="ui-card__date-large">{getEventDate(entry)}</span>
                    <h3 className="ui-card__heading"><a href={cacheFunc.getCachedUrl(entry)}>{entry.title && entry.title.length < 97 ? entry.title : entry.title.substr(0, 97).trim() + '...'}</a></h3>
                </div>;
            case 'staffProfiles':
                return <div className="ui-card__content">
                <h3 className="ui-card__heading"><a href={cacheFunc.getCachedUrl(entry)}>{entry.title1 && entry.title1.length < 90 ? entry.title1 : entry.title1.substr(0, 90).trim() + '...'}</a></h3>
                <p className="ui-card__text">{getDescText(entry)}</p>
            </div>;
            case 'showcase':
                return <div className="ui-card__content">
                <h3 className="ui-card__heading"><a href={cacheFunc.getCachedUrl(entry)}>{entry.title && entry.title.length < 90 ? entry.title : entry.title.substr(0, 90).trim() + '...'}</a></h3>
                <p className="ui-card__text">{getDescText(entry)}</p>
            </div>;
        }
    //}
}

ListingCard.propTypes = {
    entry: PropTypes.object,
    settings: PropTypes.object
};


export default ListingCard;